import styled from "styled-components";

const ImageAsset = styled.img`
  display: block;
  width: 80px;
  height: auto;
`;

export default ImageAsset;
